module.exports = function anonymous(it
) {
var out='<a class="js-user-profile" href="'+(it.url)+'" target="_blank">'+(it.label)+'</a>';return out;
}